/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLogos, FxIdDomainSettingsPublicWebClientConfigOptionsLogosFromJSONTyped, FxIdDomainSettingsPublicWebClientConfigOptionsLogosToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsLogos';
export function FxIdDomainSettingsCompanyBrandingConfigLogosFromJSON(json) {
    return FxIdDomainSettingsCompanyBrandingConfigLogosFromJSONTyped(json, false);
}
export function FxIdDomainSettingsCompanyBrandingConfigLogosFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLogos(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsLogosFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsCompanyBrandingConfigLogosToJSON(json) {
    return FxIdDomainSettingsCompanyBrandingConfigLogosToJSONTyped(json, false);
}
export function FxIdDomainSettingsCompanyBrandingConfigLogosToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLogos(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsLogosToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsCompanyBrandingConfigLogos.js.map